import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'


class CreateBloc {

    createChannel = new Subject();
    checkDateChannel = new Subject();
    checkNumberChannel = new Subject();
    getMaxDateChannel = new Subject();
    repository = new CreateRepository()

    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
        this.checkDateChannel.next({status: apiResponse.INITIAL})
        this.checkNumberChannel.next({status: apiResponse.INITIAL})
        this.getMaxDateChannel.next({status: apiResponse.INITIAL})
    }

    fetchCreate = async (query) => {
        try {
            this.createChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCreate(query).then((result) => {
                this.createChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.createChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }

    fetchCheckDate = async (query) => {
        try {
            this.checkDateChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCheckDate(query).then((result) => {
                this.checkDateChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.checkDateChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }

    fetchCheckNumber = async (query) => {
        try {
            this.checkNumberChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCheckNumber(query).then((result) => {
                this.checkNumberChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.checkNumberChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            
        }
    }

    fetchMaxDate = async (query) => {
        this.getMaxDateChannel.next({status: apiResponse.LOADING})
        try {
             await this.repository.fetchMaxDate(query).then((result) => {
                this.getMaxDateChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.getMaxDateChannel.next({status: apiResponse.ERROR, data: error})
            })           
        } catch (error) {
            console.log('rxjs', 'Subject Unsubscribed')
        }
    }
}

export default CreateBloc